module.exports = __webpack_public_path__ + "img/preimush-img-6.6cc0fa49.png";